import { useTranslation } from 'react-i18next'
import HelpTooltipIcon from '../../../../components/HelpTooltipIcon'
import { formatAverage, formatThousands } from '../../../../utils/formatNumber'
import BasicWidget from '../../Stats/components/widgets/BasicWidget'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const TotalSwipesWidget = () => {
  const { t } = useTranslation()
  const { headlineStats, isLoading } = useCountersAnalyticsData()
  const totalPlayers = headlineStats.joinedPlayers

  return (
    <BasicWidget
      title={formatThousands(headlineStats.totalSwipes)}
      subtitle={t('stats.swipes')}
      iconRight={<HelpTooltipIcon text={t('stats.tooltips.beatBoxSwipes')} />}
      chipLabel={t('stats.averageSwipes', {
        number: formatAverage(
          totalPlayers ? headlineStats.totalSwipes / totalPlayers : 0
        ),
      })}
      isLoading={isLoading}
    />
  )
}

export default TotalSwipesWidget
